export const backendServer = process.env.REACT_APP_BACKEND_URL;
